import React from 'react';
import { Button, IconButton, Input } from 'rsuite';
import styled from 'styled-components';
import { ColumnPickerPopover } from './column-picker-popover';
import { ComplaintsCounter } from './complaints-counter';
import { FilterDropdowns } from './filter-dropdowns';
import FileDownloadIcon from '@rsuite/icons/FileDownload';
const HeaderWrapper = styled.div`
  margin-bottom: 15px;
`;

const HeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  color: #333;
`;

const ControlsWrapper = styled.div`
  display: flex;
  > * {
    margin-right: 13px;
  }
`;

const StyledInput = styled(Input)`
  width: 325px;
`;

/**
 * Top part of the complaints page. Displays row count and renders controls to manipulate the grid
 *
 * @param {*} props
 */
export function ComplaintsPageHeader({
  totalComplaintsCount,
  openComplaintsCount,
  onDownloadClickCB,
  onQuickFilterDebounce,
  filterDropdownOptions,
  onFilterSelectCB,
  displayedColumns,
  onColPickerChangeCB,
  onColumnsReset,
}) {
  return (
    <HeaderWrapper>
      <HeaderTop css="display: flex; justify-content: space-between;">
        <ComplaintsCounter
          totalCount={totalComplaintsCount}
          openCount={openComplaintsCount}
        />
        <IconButton
          data-cy="complaints-download-button"
          onClick={onDownloadClickCB}
          size="sm"
          icon={<FileDownloadIcon />}
        >
          Download
        </IconButton>
      </HeaderTop>
      <ControlsWrapper>
        <StyledInput
          data-cy="complaints-universal-search-input"
          onChange={onQuickFilterDebounce()}
          placeholder="Search for an address, person or complaint type"
        />
        <FilterDropdowns
          {...filterDropdownOptions}
          onFilterSelectCB={onFilterSelectCB}
        />
        <ColumnPickerPopover
          displayedColumns={displayedColumns}
          onColPickerChangeCB={onColPickerChangeCB}
          onColumnsReset={onColumnsReset}
        />
      </ControlsWrapper>
    </HeaderWrapper>
  );
}
